<form [formGroup]="parentForm" class="form-row rowContainer">
  <ng-container [formGroupName]="groupName">
    <div class="col-lg-1 d-flex align-items-center justify-content-center">
      <app-dc-checkbox
        #checkbox
        [formControlName]="key + 'Override'"
        [id]="key + 'Override'"
      ></app-dc-checkbox>
    </div>
    <div class="col-lg-2">
      <label class="colHeader" (click)="toggleCheckbox(key, groupName)">{{ groupTitle }}</label>
    </div>
    <div class="col-lg-2">
      <app-dc-date-input
        [formControlName]="key + 'Date'"
        [id]="key + 'Date'"
        type="text"
        container="body"
        [readonly]="readonlyDate"
        (onFocusEvent)="onFocus()"
      ></app-dc-date-input>
    </div>
    <div class="col-lg-2">
      <app-dc-select
        [formControlName]="key + 'From'"
        [labelId]="key + 'From'"
        [items]="fromItems"
        closeOnSelect="true"
        dropdownParent="body"
        [readonly]="readonlyDropdowns"
        [clearSelection]="true"
      ></app-dc-select>
    </div>
    <div class="col-lg-1">
      <app-dc-select
        [formControlName]="key + 'Offset'"
        [labelId]="key + 'Offset'"
        [items]="offsetItems"
        dropdownParent="body"
        closeOnSelect="true"
        [searchable]="true"
        [FreeText]="true"
        [readonly]="readonlyDropdowns"
        [clearSelection]="true"
      ></app-dc-select>
    </div>
    <div class="col-lg-2">
      <app-dc-select
        [formControlName]="key + 'Calendar'"
        [labelId]="key + 'Calendar'"
        dropdownParent="body"
        [items]="calendarItems"
        closeOnSelect="true"
        [readonly]="readonlyDropdowns"
        [clearSelection]="true"
        [dropdownParent]="dropdownParent"
      ></app-dc-select>
    </div>
    <div class="col-lg-2 inputDiv">
      <app-dc-select
        [formControlName]="key + 'RollConvention'"
        [labelId]="key + 'RollConvention'"
        dropdownParent="body"
        [items]="rollConventionItems"
        closeOnSelect="true"
        [readonly]="readonlyDropdowns"
        [clearSelection]="true"
      ></app-dc-select>
    </div>
  </ng-container>
</form>
